export enum ExibirCustoEnum {
  Nao = 0,
  CustoCompra = 1,
  CustoMedio = 2,
}
